import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
} from "react-router-dom";

import {
  AppLayout
} from 'AWS-UI-Components-React';

import { ChangeTable } from './change_table';

const Application = (props) => {
  const { match } = props;
  const { params } = match;
  return (
        <AppLayout
                  className='awsui-util-no-gutters'
                  content={<ApplicationContent applicationName={params.applicationName} />}
                  navigationHide={true}
                  toolsHide={true}
                />
  );
}
const ApplicationContent = (props) => {
  let {applicationName} = props;
  return (
  <div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
      <div className='col-xxs-12'>
        <div className='awsui-row'>
          <div className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-10 col-l-10 offset-l-1 col-xl-'>
            <div className='awsui-text-large'>
              <div><strong>Release Note Management Tool</strong></div>
            </div>

            <div className='changesTable'>
                <ChangeTable applicationName={applicationName}/>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
);
  };

const Applications = () => {
  return (
    <div>

      <ul>
        {
          ['ShipByRegionMonsService', 'ShippingConfigPlatformService'].map((application) => (
            <li>
              <Link to={`applications/${application}`}>{application}</Link>
            </li>
          ))
        }
      </ul>
      <h3>Please select an application.</h3>

    </div>
  );
}

export class Main extends React.Component {

  render() {
    return (
      <div className="awsui">
        <Switch>
          <Route exact path='/applications'>
            <AppLayout className='awsui-util-no-gutters' content={<Applications />} navigationHide={true} toolsHide={true} />
          </Route>
          <Route path='/applications/:applicationName' component={Application} />
        </Switch>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/main.jsx